module.exports = __webpack_public_path__ + "img/character-thumbnail-both.ea1f26f8.png";